import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import { useSelector } from 'react-redux'

import Analytics from '../../analytics/Analytics'

function BusinessSelectDialog(props) {
  const retailerAccounts =
    useSelector((state) => {
      return state.auth && state.auth.user && state.auth.user.retailer_accounts
    }).sort((a, b) => {
      const name1 = a.name.toLowerCase()
      const name2 = b.name.toLowerCase()
      return name1 < name2 ? -1 : 1
    }) || []

  const handleRetailerClick = (retailerAccount) => {
    Analytics.track('Select Retailer Account', {
      retailerAccountId: retailerAccount.id,
    })
    props.handleRetailerClick && props.handleRetailerClick(retailerAccount)
  }

  return (
    <>
      {props.working ? (
        <Box my="2rem" textAlign="center">
          <CircularProgress size={64} />
        </Box>
      ) : (
        <List>
          {retailerAccounts.map((retailerAccount) => {
            const disabled =
              props.disabledCondition &&
              props.disabledCondition(retailerAccount)
            return (
              <ListItem
                button
                disabled={props.working || disabled}
                divider
                key={retailerAccount.id}
                onClick={() => handleRetailerClick(retailerAccount)}
              >
                <ListItemAvatar>
                  <Avatar
                    alt={retailerAccount.name}
                    src={retailerAccount.logo_thumbnail_url}
                    variant="rounded"
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={retailerAccount.name}
                  secondary={disabled && props.secondaryText}
                />
                <ChevronRightIcon />
              </ListItem>
            )
          })}
        </List>
      )}
    </>
  )
}

export default BusinessSelectDialog
